<template>
  <div class="form-field">
    <slot></slot>

    <p v-if="normalizedHelpText" class="form-help" :data-cy="`${id}-help`">
      {{ normalizedHelpText }}
    </p>
    <!-- Error message (renders only when provided and visible) -->
    <p v-if="errorMessage && showError" class="form-error" :id="`${id}-error`" role="alert">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  id: string
  errorMessage?: string | null
  helpText?: string | null
  showError?: boolean
}>()

const normalizedHelpText = computed(() => {
  const text = props.helpText?.trim()

  return text ? text : null
})

const showError = computed(() => !!props.errorMessage && !!props.showError)
</script>

<style scoped>
.form-error {
  color: #e32c57;
  font-size: 12px;
  line-height: normal;
  margin: 0px;
}

.form-help {
  color: var(--light-color);
  font-size: 12px;
  margin: 0px;
  opacity: 1;
}

.form-field {
  padding-bottom: 16px;
}
</style>
